import { render, staticRenderFns } from "./EntityField.vue?vue&type=template&id=47fd785f&"
import script from "./EntityField.vue?vue&type=script&lang=ts&"
export * from "./EntityField.vue?vue&type=script&lang=ts&"
import style0 from "./EntityField.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports